<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    width="1150px"
    :with-footer="false"
  >
    <TableLayout v-permissions="['book:text:query']">
      <!-- 搜索表单 -->
      <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
        <el-form-item label="文档类型" prop="docType">
          <el-select v-model="searchForm.docType" placeholder="请选择文档类型" clearable @change="searchForm.scope = null,searchForm.type = null,search()">
            <el-option v-for="type in $consts.DOCUMENT_TYPES" :key="type.value" :value="type.value" :label="type.name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="作用域" prop="scope">
          <BookScopeSelect :doc-type="searchForm.docType" v-model="searchForm.scope" @change="searchForm.type = null,search()"/>
        </el-form-item>
        <el-form-item label="文案类型" prop="type">
          <BookTextTypeSelect v-if="template != null" :template="template.code" :doc-type="searchForm.docType" :scope="searchForm.scope" v-model="searchForm.type" @change="search"/>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
      <!-- 表格和分页 -->
      <template v-slot:table-wrap>
        <ul class="toolbar" v-permissions="['book:text:create', 'book:text:delete']">
          <li><el-button type="primary" @click="$refs.operaBookTextWindow.open('新建招标书文案')" icon="el-icon-plus" v-permissions="['book:text:create']">新建</el-button></li>
          <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['book:text:delete']">删除</el-button></li>
        </ul>
        <el-table
          v-loading="isWorking.search"
          :data="tableData.list"
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="docType" label="文档类型" min-width="100px">
            <template slot-scope="{ row }">{{row.docType === 'ZBS' ? '招标书' : '系统说明书'}}</template>
          </el-table-column>
          <el-table-column prop="scope" label="作用域" min-width="100px">
            <template slot-scope="{ row }">{{row.scope === 'TEMPLATE' ? '模版' : '模块'}}</template>
          </el-table-column>
          <el-table-column prop="type" label="文案类型" min-width="150px">
            <template slot-scope="{ row }">{{row | typeText}}</template>
          </el-table-column>
          <el-table-column prop="content" label="内容" min-width="80">
            <ColumnDetail slot-scope="{ row }" :content="row.content"/>
          </el-table-column>
          <el-table-column prop="createUserInfo.realname" label="创建人" min-width="120px"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
          <el-table-column prop="updateUserInfo.realname" label="更新人" min-width="120px"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间" min-width="140px"></el-table-column>
          <el-table-column
            v-if="containPermissions(['book:text:update', 'book:text:delete'])"
            label="操作"
            min-width="120"
            fixed="right"
          >
            <template slot-scope="{row}">
              <el-button type="text" @click="$refs.operaBookTextWindow.open('编辑招标书文案', row)" icon="el-icon-edit" v-permissions="['book:text:update']">编辑</el-button>
              <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['book:text:delete']">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :pagination="tableData.pagination"
        >
        </pagination>
      </template>
      <!-- 新建/修改 -->
      <OperaBookTextWindow ref="operaBookTextWindow" :template="template" @success="handlePageChange"/>
    </TableLayout>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/common/GlobalWindow'
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaBookTextWindow from '@/components/book/OperaBookTextWindow'
import ColumnDetail from '@/components/common/ColumnDetail'
import BookScopeSelect from '@/components/book/BookScopeSelect'
import BookTextTypeSelect from '@/components/book/BookTextTypeSelect'
import { fetchByKey } from '@/api/system/config'
let _vue = null
export default {
  name: 'BookTextTableWindow',
  extends: BaseTable,
  components: { GlobalWindow, BookTextTypeSelect, BookScopeSelect, ColumnDetail, TableLayout, Pagination, OperaBookTextWindow },
  data () {
    return {
      title: '',
      visible: false,
      template: null,
      configData: {
        zbsKey: 'book:zbs:config'
      },
      // 搜索
      searchForm: {
        docType: null,
        scope: null,
        type: null
      },
      // 说明书数据
      introduceData: [],
      // 招标书模版数据
      zbsTemplateData: [],
      // 招标书模块数据
      zbsModulesData: []
    }
  },
  filters: {
    typeText (row) {
      // 文档类型为说明书
      if (row.docType === 'SYS_INT') {
        const docType = _vue.introduceData.find(item => item.type === row.type)
        if (docType != null) {
          return docType.name
        }
        return '未知类型'
      }
      // 文档类型为招标书并且作用域为模版
      if (row.docType === 'ZBS' && row.scope === 'TEMPLATE') {
        const type = _vue.zbsTemplateData.find(item => item.type === row.type)
        if (type != null) {
          return type.name
        }
        return '未知类型'
      }
      // 文档类型为招标书并且作用域为模块
      if (row.docType === 'ZBS' && row.scope === 'MODULE') {
        const type = _vue.zbsModulesData.find(item => item.type === row.type)
        if (type != null) {
          return type.name
        }
        return '未知类型'
      }
      return '未知类型'
    }
  },
  methods: {
    // 打开窗口
    open (template) {
      this.template = template
      this.configData.zbsKey = 'book:zbs:config'
      // 移动端
      if (this.template.code === 'MOBILE_MANAGE') {
        this.configData.zbsKey = 'mobile:manage:book:zbs:config'
      } else if (this.template.code === 'BIG_SCREEN') {
        this.configData.zbsKey = 'bigscreen:book:zbs:config'
      }
      this.fetchByKeyZbs()
      this.searchForm.templateId = template.id
      this.title = `配置${template.name}文案`
      this.visible = true
      this.search()
    },
    /**
     * 页码变更处理（分页时触发）
     *
     * @param pageIndex 新页码
     */
    handlePageChange (pageIndex) {
      this.tableData.pagination.pageIndex = pageIndex || this.tableData.pagination.pageIndex
      this.isWorking.search = true
      this.api.fetchList({
        page: this.tableData.pagination.pageIndex,
        capacity: this.tableData.pagination.pageSize,
        model: this.searchForm,
        sorts: this.tableData.sorts
      })
        .then(data => {
          this.tableData.list = data.records
          this.tableData.pagination.total = data.total
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking.search = false
        })
    },
    // 删除
    deleteById (row) {
      this.$dialog.deleteConfirm('确认删除该记录吗？')
        .then(() => {
          this.isWorking.delete = true
          this.api.deleteById(row[this.configData['field.id']])
            .then(() => {
              this.__afterDelete([row])
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
            .finally(() => {
              this.isWorking.delete = false
            })
        })
        .catch(() => {})
    },
    // 配置说明书
    configIntroduce () {
      fetchByKey('book:system:introduce:config')
        .then(data => {
          this.introduceData = JSON.parse(data.value).scopes[0].textTypes
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 配置招标书
    fetchByKeyZbs () {
      fetchByKey(this.configData.zbsKey)
        .then(data => {
          this.zbsTemplateData = JSON.parse(data.value).scopes[0].textTypes
          this.zbsModulesData = JSON.parse(data.value).scopes[1].textTypes
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    }
  },
  created () {
    this.configIntroduce()
    _vue = this
    this.config({
      module: '招标书文案',
      api: '/book/text',
      'field.id': 'id',
      'field.main': 'id'
    })
  }
}
</script>

<style scoped>

</style>
